"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const use_debounce_1 = require("use-debounce");
const react_2 = require("@ag-grid-community/react");
const client_side_row_model_1 = require("@ag-grid-community/client-side-row-model");
const range_selection_1 = require("@ag-grid-enterprise/range-selection");
const clipboard_1 = require("@ag-grid-enterprise/clipboard");
const rich_select_1 = require("@ag-grid-enterprise/rich-select");
require("@ag-grid-community/core/dist/styles/ag-grid.css");
require("@ag-grid-community/core/dist/styles/ag-theme-balham.css");
const api_1 = require("../../api");
const utils_1 = require("../utils");
const GridColumnTypes_1 = __importDefault(require("../Common/GridColumnTypes"));
const AuthContext_1 = require("../../Auth/AuthContext");
const quickOrderedFilter_1 = require("../quickOrderedFilter");
const gridUtils_1 = require("../gridUtils");
const Button_1 = __importDefault(require("../../forms/Button"));
const gridLocale_de_1 = __importDefault(require("../gridLocale.de"));
const CatalogsColumns_1 = require("./CatalogsColumns");
var quickFilterParsedValue = [];
const handleError_1 = __importDefault(require("../../handleError"));
const react_router_dom_1 = require("react-router-dom");
const CatalogsGrid = () => {
    const { user } = (0, AuthContext_1.useAuth)();
    const [qualityGridApi, setQualityGridApi] = (0, react_1.useState)(null);
    const [, setGridColumnApi] = (0, react_1.useState)(null);
    const [isUserEditingGrid, setIsUserEditingGrid] = (0, react_1.useState)(false);
    const [remoteTransactionsQueue, setRemoteTransactionsQueue] = (0, react_1.useState)([]);
    const [quickFilterText, setQuickFilterText] = (0, react_1.useState)('');
    const [debouncedQuickFilterText] = (0, use_debounce_1.useDebounce)(quickFilterText, 300);
    const catalogApi = new api_1.CatalogApi();
    (0, react_1.useEffect)(() => {
        quickFilterParsedValue = debouncedQuickFilterText ? debouncedQuickFilterText.toString().toLowerCase().split(' ') : [];
        if (qualityGridApi)
            qualityGridApi.onFilterChanged();
    }, [debouncedQuickFilterText]);
    const gridModules = [
        range_selection_1.RangeSelectionModule,
        client_side_row_model_1.ClientSideRowModelModule,
        clipboard_1.ClipboardModule,
        rich_select_1.RichSelectModule
    ];
    function onGridReady(params) {
        setQualityGridApi(params.api);
        setGridColumnApi(params.columnApi);
        const fetchData = async () => {
            params.api.showLoadingOverlay();
            try {
                const data = await catalogApi.index();
                params.api.setColumnDefs((0, CatalogsColumns_1.catalogsColumns)(data.catalogColumnKey, data.catalogColumnName));
                params.api.setRowData(data.items);
            }
            catch (e) {
                (0, handleError_1.default)(e);
            }
            params.api.hideOverlay();
        };
        fetchData().then(() => { });
    }
    const onFirstDataRendered = (event) => {
    };
    const defaultColDef = {
        flex: 1,
        minWidth: 75,
        filter: true,
        // editable: (params) => {
        //     return isAllowed(user, ['update_plant_option']);
        // },
        resizable: true,
        sortable: true,
        floatingFilter: true,
        enablePivot: false,
        enableValue: false,
        enableRowGroup: false,
        cellClass: 'default',
    };
    const updatePlants = async (updates, apiG) => {
        const apiGrid = apiG || qualityGridApi;
        try {
            const { changes } = await catalogApi.update({ updates });
            changes.map(change => {
                const rowNode = apiGrid.getRowNode(change.id);
                const a = updates.find(o => o.id === change.id);
                for (const [column, value] of Object.entries(change)) {
                    if (a.column !== column && apiGrid.getColumnDef(column) !== null) {
                        rowNode.setDataValue(column, value);
                    }
                }
            });
        }
        catch (error) {
            (0, handleError_1.default)(error);
        }
    };
    const debouncedUpdate = (0, utils_1.debounceAgg)(updatePlants, 250);
    const doesExternalFilterPass = (node) => {
        return (0, quickOrderedFilter_1.quickOrderedFilter)((node.data['botanisch_slugged'] || '').split("-"), quickFilterParsedValue);
    };
    const isExternalFilterPresent = () => {
        return quickFilterParsedValue.length > 0;
    };
    const gridOptions = {
        enableRangeSelection: true,
        multiSortKey: 'ctrl',
        getRowNodeId: (data) => {
            return data.id;
        },
        isExternalFilterPresent: isExternalFilterPresent,
        doesExternalFilterPass: doesExternalFilterPass,
        excelStyles: [
            {
                id: 'default',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'derived',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'header',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            }
        ],
    };
    const cellValueChanged = async (event) => {
        const { data } = event;
        const { newValue = null, oldValue = null } = event;
        if (newValue === oldValue) {
            return;
        }
        const isEditable = event.column.isCellEditable(event.node);
        if (isEditable) {
            const column = event.column.getColId();
            const { id } = data;
            try {
                debouncedUpdate({ id, column, value: newValue });
            }
            catch (e) {
                (0, handleError_1.default)(e);
            }
        }
    };
    const resetFilters = () => {
        qualityGridApi.setFilterModel(null);
        setQuickFilterText('');
        qualityGridApi.onFilterChanged();
    };
    const cellEditingStarted = (e) => {
        setIsUserEditingGrid(true);
    };
    const cellEditingStopped = (e) => {
        setIsUserEditingGrid(false);
    };
    const gridTable = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_2.AgGridReact
        // @ts-ignore
        , { 
            // @ts-ignore
            modules: gridModules, localeText: gridLocale_de_1.default, disableStaticMarkup: true, onGridReady: onGridReady, onFirstDataRendered: onFirstDataRendered, onCellKeyDown: gridUtils_1.onCellKeyDown, onCellEditingStarted: cellEditingStarted, onCellEditingStopped: cellEditingStopped, rowSelection: 'multiple', suppressCopyRowsToClipboard: true, enableRangeSelection: true, undoRedoCellEditing: true, enableCellChangeFlash: true, animateRows: true, enableFillHandle: true, fillHandleDirection: 'y', gridOptions: gridOptions, columnDefs: [], defaultColDef: defaultColDef, columnTypes: GridColumnTypes_1.default, rowData: [], getRowNodeId: (data) => data.id, onCellValueChanged: cellValueChanged }));
    }, [qualityGridApi]);
    return (react_1.default.createElement("div", { className: "ag-theme-balham flex flex-col w-full flex-1" },
        react_1.default.createElement("div", { className: 'mb-2 flex items-end space-x-4' },
            react_1.default.createElement("div", { className: 'max-w-lg' },
                react_1.default.createElement("input", { type: "text", id: "filter-text-box", className: 'form-input', placeholder: "Suche...", value: quickFilterText, onChange: e => setQuickFilterText(e.target.value) })),
            react_1.default.createElement("div", { className: 'space-x-2 flex flex-1' },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/catalogs/export", className: "link-button" }, "Schritt 2")),
            react_1.default.createElement("div", { className: 'space-x-1' },
                react_1.default.createElement(Button_1.default, { onClick: () => resetFilters(), size: 'sm', variant: 'white' }, "Filter zur\u00FCcksetzen"),
                react_1.default.createElement(Button_1.default, { onClick: () => qualityGridApi.undoCellEditing(), size: 'sm', variant: 'white' }, "Undo"),
                react_1.default.createElement(Button_1.default, { onClick: () => qualityGridApi.redoCellEditing(), size: 'sm', variant: 'white' }, "Redo"))),
        gridTable));
};
exports.default = CatalogsGrid;
